/* eslint-disable */

import * as clientService from "./httpsClient";

export const getGroups = async (accessToken, params) => {
  const { page, limit, values } = params;
  let object = {
    page: page ? page : 0,
    limit: limit ? limit : 10,
  };
  if (values != undefined) {
    object.name = values.name;
  }

  try {
    return await clientService.getApi(`usermangement/groups`, accessToken, object);
  } catch (error) {
    throw error;
  }
};

export const getGroupRolePermissions = async (accessToken, body) => {
  try {
    const domain = `usermangement/groups/permissions`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const createGroupRolePermission = async (accessToken, body) => {
  try {
    const domain = `usermangement/groups`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateGroupRolePermission = async (accessToken, body) => {
  // const { id } = body
  try {
    const domain = `usermangement/groups`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteGroup = async (accessToken, body) => {
  try {
    const domain = `usermangement/groups`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};
